export default "__VITE_ASSET__Bv_Z$S7G__"